import { render, staticRenderFns } from "./NutrientSelector.vue?vue&type=template&id=c0fa57ce&scoped=true&lang=html&"
import script from "./NutrientSelector.vue?vue&type=script&lang=js&"
export * from "./NutrientSelector.vue?vue&type=script&lang=js&"
import style0 from "./NutrientSelector.vue?vue&type=style&index=0&id=c0fa57ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fa57ce",
  null
  
)

export default component.exports